import React from 'react';
import styled from 'styled-components';

import OrtizYear from './OrtizYear';
import OrtizLegend from './OrtizLegend';
import byYearData from '../../assets/data/hrs-by-year.json';

import year1997 from '../../assets/images/year1997.jpg';
import year1998 from '../../assets/images/year1998.jpg';
import year2000 from '../../assets/images/year2000.jpg';
import year2001 from '../../assets/images/year2001.jpg';
import year2002 from '../../assets/images/year2002.jpg';
import year2003 from '../../assets/images/year2003.jpg';
import year2004 from '../../assets/images/year2004.jpg';
import year2005 from '../../assets/images/year2005.jpg';
import year2006 from '../../assets/images/year2006.jpg';
import year2007 from '../../assets/images/year2007.jpg';
import year2008 from '../../assets/images/year2008.jpg';
import year2009 from '../../assets/images/year2009.jpg';
import year2010 from '../../assets/images/year2010.jpg';
import year2011 from '../../assets/images/year2011.jpg';
import year2012 from '../../assets/images/year2012.jpg';
import year2013 from '../../assets/images/year2013.jpg';
import year2014 from '../../assets/images/year2014.jpg';
import year2015 from '../../assets/images/year2015.jpg';
import year2016 from '../../assets/images/year2016.jpg';

const images = [
  year1997,
  year1998,
  year2000,
  year2001,
  year2002,
  year2003,
  year2004,
  year2005,
  year2006,
  year2007,
  year2008,
  year2009,
  year2010,
  year2011,
  year2012,
  year2013,
  year2014,
  year2015,
  year2016,
];

const ByYearGraphic = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 30px;
  grid-row-gap: 30px;
  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 450px) {
    grid-template-columns: 1fr;
    grid-row-gap: 2rem;
  }
`;

const HomerunsByYear = () => (
  <React.Fragment>
    <OrtizLegend />
    <ByYearGraphic id="by-year__container">
      {byYearData.map((d, i) => (
        <OrtizYear
          data={d}
          image={images[i]}
          key={`homeruns-by-year-${d.year}`}
        />
      ))}
    </ByYearGraphic>
  </React.Fragment>
);

export default HomerunsByYear;
